import { SearchOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';

import { MultipleSelect } from '@app/components';

import { getSelectedOptions } from '@pages/DublicateClients/utils';

import { PF } from '@pages/DublicateClients/data/constants';
import type { FiltersProps } from '@pages/DublicateClients/types';

import type { FC } from 'react';

export const Filters: FC<FiltersProps> = ({
  onChangeSearchTerm,
  unsavedFilters: { SearchTerm, statusesIds },
  disabled = false,
  onSearch,
  skipFilters,
  statusesOptions,
  onChangeStatuses,
}) => (
  <div className={`${PF}_filters`}>
    <Input
      addonBefore={<SearchOutlined />}
      placeholder="Введите ID клиента"
      value={SearchTerm ?? ''}
      onChange={onChangeSearchTerm}
      className={`${PF}_filters_search`}
      disabled={disabled}
      onPressEnter={onSearch}
    />
    <MultipleSelect
      className={`${PF}_filters_select`}
      placeholder="Все категории"
      allOptions={statusesOptions}
      selectedOption={getSelectedOptions(statusesOptions, statusesIds)}
      setSelectedOptions={onChangeStatuses}
      disabled={disabled}
    />
    <div className={`${PF}_filters_buttons`}>
      <Button
        htmlType="reset"
        onClick={skipFilters}
        className={`${PF}_filters_buttons_item`}
      >
        <CloseCircleOutlined />
        Сброс
      </Button>
      <Button
        type="primary"
        onClick={onSearch}
        className={`${PF}_filters_buttons_item`}
      >
        Показать
      </Button>
    </div>
  </div>
);
